import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import "./App.css";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { API } from "@/lib/constants";
import { ServicePage } from "@/pages/ServicePage";
import { LocationPage } from "@/pages/LocationPage";
import MainPage from "@/pages/MainPage";
import CareersPage from "@/pages/CareersPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminCareersPage from "@/pages/AdminCareersPage";
import AdminContactsPage from "@/pages/AdminContactsPage";
import AdminSitePhotosPage from "@/pages/AdminSitePhotosPage";

const ServicePageWrapper = ({ language }) => {
  const { slug } = useParams();
  return (
    <div className="min-h-screen bg-[#f4f6fb]">
      <Header language={language} />
      <ServicePage slug={slug} />
      <Footer language={language} />
    </div>
  );
};

const LocationPageWrapper = ({ slug, language }) => {
  return (
    <div className="min-h-screen bg-[#f4f6fb]">
      <Header language={language} />
      <LocationPage slug={slug} />
      <Footer language={language} />
    </div>
  );
};

const PageViewTracker = () => {
  const location = useLocation();
  useEffect(() => {
    axios
      .post(`${API}/analytics/pageview`, { path: location.pathname })
      .catch(() => {});
  }, [location.pathname]);
  return null;
};

function App() {
  const language = "en";

  useEffect(() => {
    document.documentElement.lang = "en";
    if (typeof document !== "undefined") {
      document.body.removeAttribute("data-language");
    }
  }, []);

  return (
    <BrowserRouter>
      <PageViewTracker />
      <Routes>
        <Route path="/" element={<MainPage language={language} />} />
        <Route path="/careers" element={<CareersPage language={language} />} />
        <Route path="/admin-login" element={<AdminLoginPage language={language} />} />
        <Route path="/admin-dashboard" element={<AdminDashboardPage language={language} />} />
        <Route
          path="/admin-dashboard/careers"
          element={<AdminCareersPage language={language} />}
        />
        <Route
          path="/admin-dashboard/contacts"
          element={<AdminContactsPage language={language} />}
        />
        <Route
          path="/admin-dashboard/site-photos"
          element={<AdminSitePhotosPage language={language} />}
        />
        <Route path="/admin/resumes" element={<Navigate to="/admin-login" replace />} />
        <Route
          path="/services/:slug"
          element={<ServicePageWrapper language={language} />}
        />
        <Route
          path="/epc-contractor-lucknow"
          element={
            <LocationPageWrapper slug="epc-contractor-lucknow" language={language} />
          }
        />
        <Route
          path="/epc-contractor-uttar-pradesh"
          element={
            <LocationPageWrapper slug="epc-contractor-uttar-pradesh" language={language} />
          }
        />
        <Route
          path="/epc-contractor-delhi-ncr"
          element={
            <LocationPageWrapper slug="epc-contractor-delhi-ncr" language={language} />
          }
        />
        <Route
          path="/epc-contractor-india"
          element={
            <LocationPageWrapper slug="epc-contractor-india" language={language} />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
